export default __webpack_public_path__ + "static/media/Congestive-Heart-Failure-1.1363bd93.jpg";